// Notificação "Na vez" — banner nativo + som (Web Audio) + vibração + Service Worker (lock screen)
// Sem dependências externas.

const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";
const devWarn = (label, err) => {
  if (isDev && typeof console !== "undefined") console.debug(`[notify] ${label}`, err);
};

let audioCtx = null;

export function playBeep() {
  try {
    if (!audioCtx) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      audioCtx = new Ctx();
    }
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    // dois "dings" curtos (~880Hz e 1175Hz)
    [
      { f: 880, t: 0 },
      { f: 1175, t: 0.25 },
    ].forEach(({ f, t }) => {
      const osc = audioCtx.createOscillator();
      const gain = audioCtx.createGain();
      osc.type = "sine";
      osc.frequency.value = f;
      gain.gain.setValueAtTime(0.0001, now + t);
      gain.gain.exponentialRampToValueAtTime(0.35, now + t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.22);
      osc.connect(gain).connect(audioCtx.destination);
      osc.start(now + t);
      osc.stop(now + t + 0.24);
    });
  } catch (err) {
    devWarn("audio unsupported", err);
  }
}

export function vibrate() {
  try {
    if (navigator.vibrate) navigator.vibrate([200, 80, 200]);
  } catch (err) {
    devWarn("vibrate unsupported", err);
  }
}

export function notificationsSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function notificationPermission() {
  if (!notificationsSupported()) return "unsupported";
  return Notification.permission; // 'granted' | 'denied' | 'default'
}

export async function requestNotificationPermission() {
  if (!notificationsSupported()) return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch (e) {
    return "denied";
  }
}

async function swNotify(title, body) {
  try {
    if (!("serviceWorker" in navigator)) return false;
    const reg = await navigator.serviceWorker.ready;
    if (!reg) return false;
    // Fire via SW so it works even when tab is hidden / phone locked (in PWA mode)
    reg.active?.postMessage({ type: "NA_VEZ_NOTIFY", title, body });
    return true;
  } catch (e) {
    return false;
  }
}

export function showBrowserNotification(title, body) {
  try {
    if (!notificationsSupported()) return;
    if (Notification.permission !== "granted") return;
    // Prefer service worker notification (persistent + lockscreen)
    swNotify(title, body).then((ok) => {
      if (!ok) {
        const n = new Notification(title, {
          body,
          icon: "/icon-192.png",
          tag: "fila-le-rose-na-vez",
          renotify: true,
          requireInteraction: false,
        });
        setTimeout(() => n.close(), 8000);
      }
    });
  } catch (err) {
    devWarn("notification failed", err);
  }
}

export function fireNaVezNotification(categoryNames) {
  const cats = Array.isArray(categoryNames) ? categoryNames.join(" · ") : String(categoryNames || "");
  playBeep();
  vibrate();
  showBrowserNotification("Você é a próxima da vez", cats ? `Categoria: ${cats}` : "Prepare-se para atender.");
}
